import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  MdRowActions,
  MdTableActionsCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function getEstadoInscripcion(estado) {
  if (estado === 'A') return 'Activa';
  if (estado === 'P') return 'Pendiente';
  if (estado === 'G') return 'Acta Generada';
  return 'Lista';
}

function getEstadoBadgeClass(estado) {
  if (estado === 'P') return 'md-page__badge md-page__badge--warning';
  if (estado === 'A') return 'md-page__badge md-page__badge--success';
  if (estado === 'G') return 'md-page__badge md-page__badge--info';
  return 'md-page__badge';
}

export class MDInscripcionCursada extends Component {
  static displayName = MDInscripcionCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      activatingId: null,
      pendingDelete: null,
      pendingActivate: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('WWInscripcionCursada')) {
      this.populateData();
    }
  }

  handleRemoveItem = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: periodo.inscripcionCursadaCod,
        nombre: periodo.alumno + ' — ' + periodo.materia,
      },
    });
  };

  handleActivateRequest = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingActivate: {
        id: periodo.inscripcionCursadaCod,
        nombre: periodo.alumno + ' — ' + periodo.materia,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handleCancelActivate = () => {
    if (this.state.activatingId) return;
    this.setState({ pendingActivate: null });
  };

  handleConfirmActivate = () => {
    const { pendingActivate } = this.state;
    if (!pendingActivate || isMdMutationLocked(this)) return;
    this.changeItem(pendingActivate.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  buildRowActions(periodo) {
    const id = periodo.inscripcionCursadaCod;
    const estado = periodo.inscripcionCursadaEstado;
    const actions = [];

    if (estado === 'P' || estado === 'A') {
      actions.push({
        key: 'edit',
        label: 'Modificar',
        variant: 'primary',
        icon: 'pencil',
        to: '/update-ic/' + id + '/0',
      });
      actions.push({
        key: 'delete',
        label: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',
        variant: 'danger',
        icon: 'trash',
        onClick: () => this.handleRemoveItem(periodo),
        disabled: this.state.loading || this.state.deletingId === id,
      });
    }

    actions.push({
      key: 'detail',
      label: 'Detalles',
      variant: 'outline',
      icon: 'info',
      to: '/update-ic/' + id + '/1',
    });

    if (estado === 'P') {
      actions.push({
        key: 'activate',
        label: this.state.activatingId === id ? 'Activando...' : 'Activar',
        variant: 'primary',
        icon: 'check',
        onClick: () => this.handleActivateRequest(periodo),
        disabled: this.state.loading || this.state.activatingId === id,
      });
    }

    return actions;
  }

  renderTable(periodos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed md-inscripcion-cursada__table" aria-labelledby="md-inscripcion-cursada-title">
          <colgroup>
            <col className="md-inscripcion-cursada__col-alumno" />
            <col className="md-inscripcion-cursada__col-materia" />
            <col className="md-inscripcion-cursada__col-carrera" />
            <col className="md-inscripcion-cursada__col-fecha" />
            <col className="md-inscripcion-cursada__col-estado" />
            <col className="md-inscripcion-cursada__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--alumno">Alumno</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--materia">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--carrera">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--fecha">Fecha de Inscripción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--estado md-page__table__badge-cell md-page__table__badge-cell--lg">Estado</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {periodos.map((periodo) => (
              <tr key={periodo.inscripcionCursadaCod}>
                <td className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--alumno md-page__table__cell--text">{periodo.alumno}</td>
                <td className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--materia md-page__table__cell--text">{periodo.materia}</td>
                <td className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--carrera md-page__table__cell--text">{periodo.carrera}</td>
                <td className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--fecha md-page__table__cell--date">
                  {constantClass.formatDisplayDate(periodo.inscripcionCursadaFechaHora)}
                </td>
                <td className="md-inscripcion-cursada__cell md-inscripcion-cursada__cell--estado md-page__table__cell--text md-page__table__badge-cell md-page__table__badge-cell--lg">
                  <span className={getEstadoBadgeClass(periodo.inscripcionCursadaEstado)}>
                    {getEstadoInscripcion(periodo.inscripcionCursadaEstado)}
                  </span>
                </td>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(periodo)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId && !this.state.activatingId;
    const { pendingDelete, pendingActivate } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-inscripcion-cursada">
        <h1 id="md-inscripcion-cursada-title" className="md-page__title">Manejar Datos de Inscripciones a Cursadas</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <div className="md-page__toolbar">
          <Link className="md-page__action-link" to="/add-ic">
            <PlusIcon />
            Nueva Inscripción
          </Link>
          <Link className="md-page__action-link" to="/vic">
            Validar Inscripciones
          </Link>
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese Alumno o Materia"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar inscripción"
          message="Esta acción eliminará la inscripción a cursada y no se puede deshacer."
          detail={pendingDelete ? pendingDelete.nombre : ''}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />

        <ConfirmDialog
          open={Boolean(pendingActivate)}
          title="Activar inscripción"
          message="¿Desea activar esta inscripción a cursada?"
          detail={pendingActivate ? pendingActivate.nombre : ''}
          confirmLabel="Activar"
          cancelLabel="Cancelar"
          variant="primary"
          loading={Boolean(this.state.activatingId)}
          onConfirm={this.handleConfirmActivate}
          onCancel={this.handleCancelActivate}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/ic/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/ic/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar la inscripción. Intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'La inscripción se eliminó correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }

  async changeItem(id) {
    this.clearFeedback();
    this.setState({ activatingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/ic/changeStatus/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo activar la inscripción. Intente nuevamente.'
          ),
          pendingActivate: null,
        });
        return;
      }
      this.setState({ successMessage: 'La inscripción se activó correctamente.', pendingActivate: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ activatingId: null });
  }
}
